import React, { useEffect, setGlobal, useState } from 'reactn';
import { Button, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { saveState, noOp, apiFetch } from 'meta/util';
import { history, BASE_WEB_URL } from 'meta/constants';
import Page from 'components/Page';
import { DiscordUser } from 'meta/types';

async function handleAuth(code: string) {
	const data = await apiFetch({
		path: '/oauth/callback',
		method: 'POST',
		body: {
			code,
			redirect_uri: `${BASE_WEB_URL}/oauth/callback`
		}
	});

	const _partialUser = data.user;

	if (data.error || !_partialUser || !data.access_token) {
		throw new Error('Error fetching token.');
	}

	const user: DiscordUser = {
		..._partialUser,
		avatar: `https://cdn.discordapp.com/avatars/${_partialUser.id}/${_partialUser.avatar}?size=256`
	};

	setGlobal({ user, token: data.access_token, authenticated: true }).catch(noOp);
	history.push('/');

	saveState('discord_token', data.access_token);
	saveState('discord_user', user);
}

interface Props {}

const OAuthPage: React.FC<Props> = () => {
	const [error, setError] = useState('');

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const code = urlParams.get('code');

		if (code) {
			handleAuth(code).catch(setError);
		}
	}, []);

	return (
		<Page>
			<Typography variant="h3" component="h1">
				{(error && `Error: ${error}`) || 'Loading...'}
			</Typography>
			{error && (
				<Button component={Link} to="/">
					Back home
				</Button>
			)}
		</Page>
	);
};

export default OAuthPage;
